import React from 'react';
import { site } from '../data/site';
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <a href="#top" className="group inline-flex items-center gap-3" aria-label={`${site.name} ${site.category} home`} data-id="element-96" data-mp="8uea9oyyayjj">
      <img src="https://cdn.magicpatterns.com/uploads/xm1VAa6YiTAPp6eiJScRyj/radiant-logo.png" alt="" className={`h-11 w-11 shrink-0 object-contain ${inverted ? 'rounded-full bg-white p-1' : ''}`} data-id="element-97" data-mp="3v84oj3jh2mgu" />
      <span className="leading-none" data-id="element-98" data-mp="rr61ckkqihy5">
        <span className={`block text-[13px] font-semibold uppercase tracking-[0.22em] ${inverted ? 'text-white' : 'text-[#0B2A6B]'}`} data-id="element-99" data-mp="dsg3h2q3ce8q">
          Radiant Reflections
        </span>
        <span className={`mt-1 block text-[10px] uppercase tracking-[0.3em] ${inverted ? 'text-sky-200' : 'text-[#1D4ED8]'}`} data-id="element-100" data-mp="2yi5fl7zetlxq">
          {site.category}
        </span>
      </span>
    </a>;
}